export const interfaceDensityTranslations = {
  fr: {
    'Table density': 'Densité du tableau',
    'Compact': 'Compacte',
    'Comfortable': 'Confortable',
    'Spacious': 'Spacieuse',
    'Density changed, but could not be saved in this browser.': 'La densité a changé, mais n’a pas pu être enregistrée dans ce navigateur.',
  },
  ar: {
    'Table density': 'كثافة الجدول',
    'Compact': 'مضغوطة',
    'Comfortable': 'مريحة',
    'Spacious': 'واسعة',
    'Density changed, but could not be saved in this browser.': 'تم تغيير الكثافة، لكن تعذّر حفظها في هذا المتصفح.',
  },
  tr: {
    'Table density': 'Tablo yoğunluğu',
    'Compact': 'Sıkışık',
    'Comfortable': 'Rahat',
    'Spacious': 'Geniş',
    'Density changed, but could not be saved in this browser.': 'Yoğunluk değiştirildi ancak bu tarayıcıda kaydedilemedi.',
  },
}
